var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "d-flex flex-wrap align-center" }, [
    _c(
      "a",
      { staticClass: "mt-1", attrs: { href: _vm.dashboardUrl } },
      [_c("v-icon", [_vm._v("dashboard")]), _vm._v("Dashboard")],
      1
    ),
    _vm._v(" "),
    _c(
      "a",
      { staticClass: "mt-1", attrs: { href: _vm.dailyPlannerUrl } },
      [_c("v-icon", [_vm._v("edit_calendar")]), _vm._v("Daily Planner")],
      1
    ),
    _vm._v(" "),
    _c(
      "a",
      { staticClass: "mt-1", attrs: { href: _vm.batchLoaderUrl } },
      [_c("v-icon", [_vm._v("upload_file")]), _vm._v("Batch Loader")],
      1
    ),
    _vm._v(" "),
    _c(
      "a",
      { staticClass: "mt-1", attrs: { href: _vm.specialOffersUrl } },
      [_c("v-icon", [_vm._v("star")]), _vm._v("Special Offers")],
      1
    ),
    _vm._v(" "),
    _c(
      "a",
      { staticClass: "mt-1", attrs: { href: _vm.changeLogUrl } },
      [_c("v-icon", [_vm._v("history")]), _vm._v("Change Log")],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }